// extracted by mini-css-extract-plugin
export var actions = "_3o-0";
export var actionsContainer = "_3o-6";
export var border = "_3o-1";
export var childFullHeight = "_3o-d";
export var collapse = "_3o-2";
export var content = "_3o-8";
export var contentChild = "_3o-c";
export var fullscreen = "_3o-a";
export var headerContainer = "_3o-3";
export var headerRow = "_3o-5";
export var hidePadding = "_3o-9";
export var noScrollX = "_3o-e";
export var noScrollY = "_3o-f";
export var optOutTopPadding = "_3o-b";
export var pagePadding = "_3o-7";
export var profile = "_3o-g";
export var profileContainer = "_3o-h";
export var profileImage = "_3o-i";
export var profileMain = "_3o-j";
export var profileSubtitle = "_3o-l";
export var profileTitle = "_3o-k";
export var tabsWrapper = "_3o-4";
export var title = "_3o-m";